import throttle from 'lodash.throttle'
import tailwindDefaultTheme from 'tailwindcss/defaultTheme'

export default {
  width: window.innerWidth,
  height: window.innerHeight,
  breakpoints: Object.fromEntries(
    Object.entries(tailwindDefaultTheme.screens).map((entry) => {
      return [entry[0], parseInt(entry[1])]
    })
  ),
  init() {
    const onResize = throttle(() => {
      this.width = window.innerWidth
      this.height = window.innerHeight
    }, 300)
    window.addEventListener('resize', onResize)
  },
  breakpoint(key = null) {
    if (key && this.breakpoints.hasOwnProperty(key)) {
      return this.breakpoints[key]
    }
  }
}
